import { cn } from '@up2stay/up2promo-ui';
import type { ReactNode } from 'react';

export function UsageBar({
  label,
  current,
  limit,
  detail,
  trailing,
  empty,
}: {
  label: string;
  current: number;
  limit: number;
  detail: string;
  trailing?: ReactNode;
  /** Force empty track (e.g. Free reputation gate). */
  empty?: boolean;
}) {
  const percentage =
    empty || limit <= 0
      ? 0
      : Math.min((current / Math.max(limit, 1)) * 100, 100);
  const isOver = !empty && limit > 0 && current > limit;

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-baseline gap-2">
        <span className="min-w-0 flex-1 text-sm font-medium text-foreground">
          {label}
        </span>
        {trailing}
        {!empty && limit > 0 ? (
          <span className="font-mono text-[13px] tabular-nums text-foreground">
            {current} / {limit}
          </span>
        ) : null}
      </div>
      <div className="h-2 overflow-hidden rounded bg-muted/80 dark:bg-muted/40">
        <div
          className={cn(
            'h-2 rounded transition-[width] duration-200',
            isOver ? 'bg-destructive' : 'bg-primary',
          )}
          style={{ width: `${percentage}%` }}
        />
      </div>
      <span className="text-xs text-muted-foreground">{detail}</span>
    </div>
  );
}

/** Usage row for an unlimited quota: same label as the bar, no track (DEV-771). */
export function UnlimitedUsageRow({
  label,
  detail,
}: {
  label: string;
  detail: string;
}) {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-sm font-medium text-foreground">{label}</span>
      <span className="text-xs text-muted-foreground">{detail}</span>
    </div>
  );
}
